export class Routes {
  public static readonly loginPage = 'login';
  public static readonly recoverPasswordPage = 'recover-password';
  public static readonly dashboardPage = 'dashboard';
  public static readonly usersPage = 'users';
  public static readonly usersAddPage = 'users/add';
  public static readonly usersEditPage = 'users/edit/:id';
  public static readonly businessesPage = 'businesses';
  public static readonly businessesAddGroupPage = 'businesses/add-group';
  public static readonly businessesEditGroupPage = 'businesses/edit-group/:id';
  public static readonly businessesAddPage = 'businesses/add';
  public static readonly businessesEditPage = 'businesses/edit/:id';
  public static readonly officesPage = 'offices';
  public static readonly officesAddPage = 'offices/add';
  public static readonly officesEditPage = 'offices/edit/:id';
  public static readonly officesBulkUploadPage = 'offices/bulk-upload';
  public static readonly formsPage = 'forms';
  public static readonly emissionsFactorsPage = 'emissions/factors';
  public static readonly emissionsSourcesPage = 'emissions/sources';
  public static readonly resultsReportsPage = 'reports/results';
  public static readonly resultsByMonthReportsPage = 'reports/results-by-month';
}
